"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  author: "Morten H.",
  quote: "Xora har revolusjonert hvordan vi håndterer oppfølging. AI-automatiseringen sparer oss for timer hver eneste dag.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646994/img/broker_morten.png"
}, {
  author: "Camilla S.",
  quote: "Den mest sømløse integrasjonen jeg har opplevd. Kundene våre får svar umiddelbart, selv når vi er på visning.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646994/img/broker_camilla.png"
}, {
  author: "Andreas V.",
  quote: "Presisjonen i AI-analysene gir oss et enormt konkurransefortrinn i et tøft eiendomsmarked. Helt uunnværlig.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646994/img/broker_andreas.png"
}];
export default function VoicesFromTheTable() {
  return;
}